module.exports = __webpack_public_path__ + "static/img/18.4561ea6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/18.png
// module id = vmuz
// module chunks = 0